import { FaCheckCircle } from 'react-icons/fa';
import { IoWarning } from 'react-icons/io5';

import { RedactionDisplayStatus } from '~/core/shared/constants';

export const getRedactionDisplayConfig = (status?: RedactionDisplayStatus) => {
  switch (status) {
    case RedactionDisplayStatus.Passed:
      return {
        color: 'fg',
        bgColor: 'green.subtle',
        iconColor: 'green.fg',
        icon: FaCheckCircle,
        displayText: 'Passed',
      };
    case RedactionDisplayStatus.Failed:
      return {
        color: 'red.contrast',
        bgColor: 'red.solid',
        iconColor: 'red.contrast',
        icon: IoWarning,
        displayText: 'Failed',
      };
    case RedactionDisplayStatus.Pending:
      return {
        color: 'gray.fg',
        bgColor: 'gray.subtle',
        iconColor: 'gray.fg',
        icon: undefined,
        displayText: 'Pending',
      };
    default:
      return {
        color: 'gray.fg',
        bgColor: 'gray.subtle',
        iconColor: 'gray.fg',
        icon: undefined,
        displayText: 'Not applicable',
      };
  }
};
